import axios from 'axios'
import BaseModel from '@/models/BaseModel.js'

export default class Rkas extends BaseModel {
  fields =  {
    'account_code_id': {
      label: 'Kode Rekening',
      type: 'enum',
      rules: 'required',
      options: []
    },
    'nama_kegiatan' : {
      label: 'Nama Kegiatan',
      type: 'text',
      rules: 'required'
    },
    'uraian_kegiatan' : {
      label: 'Uraian Kegiatan',
      type: 'text',
      rules: 'required'
    },
    'bulan_kegiatan' : {
      label: 'Bulan Kegiatan',
      type: 'date',
      rules: 'required'
    },
    'harga_satuan' : {
      label: 'Harga Satuan',
      type: 'number',
      rules: 'required'
    },
    'jenis_satuan' : {
      label: 'Jenis Satuan',
      type: 'text',
      rules: 'required'
    },
    'total_harga' : {
      label: 'Total Harga',
      type: 'number',
      rules: 'required'
    },
    'volume' : {
      label: 'Volume',
      type: 'number',
      rules: 'required'
    },
    'frekuensi' : {
      label: 'Frekuensi',
      type: 'text',
      rules: ''
    },
    'school_id' : {
      label: 'Sekolah',
      type: 'enum',
      rules: 'required',
      options: []
    }
  }

  endpoint = process.env.VUE_APP_API_URL + 'school-purchases'
}